import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

interface RemoveContactModalProps {
  readonly open: boolean;
  readonly isRemoving: boolean;
  readonly onClose: () => void;
  readonly onRemove: () => Promise<void>;
}

function RemoveContactModal({
  open,
  isRemoving,
  onClose,
  onRemove,
}: RemoveContactModalProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box className="flex items-center gap-2">Remove Contact</Box>
      </DialogTitle>
      <DialogContent>
        <Box className="space-y-4">
          <Typography variant="body1">
            Are you sure you want to remove this contact?
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button disabled={isRemoving} onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="error"
          disabled={isRemoving}
          onClick={onRemove}
        >
          Remove
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default RemoveContactModal;
